import { useAppDispatch } from "hooks/redux";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { setHiveTab } from "store/reducers/HiveDetails/hiveSettings";

const HiveMembers = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHiveTab(2));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default HiveMembers;
